import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { MatterOverageDNSDto } from '@/models/audit/MatterOverageDNSDto';

export class AuditingService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, '/api/auditing');
  }

  public async auditCompleted(clientId: Guid): Promise<{ Value: boolean }> {
    return await this.client.get(`/${clientId}/completed`);
  }

  public async toggleMatterOverageDNS(dto: MatterOverageDNSDto) {
    return await this.client.postJson('/toggleDNS', dto);
  }

  public async getAllMatterOverageDNS(clientId: Guid) {
    return await this.client.get(`/matterDNS/${clientId}`);
  }

  public async getMatterOverageMilestones(matterId: Guid) {
    return await this.client.get(`/matterOverageMilestones/${matterId}`);
  }

  public async getMatterWorkMiletones(matterWorkId: Guid) {
    return await this.client.get(`/matterWorkMilestones/${matterWorkId}`);
  }

  public async updateClientSnapshot(clientId: Guid) {
    return await this.client.postJson(`/client-snapshot/${clientId}`, new Object());
  }
}
